
import Vue, {PropType} from 'vue'
export default Vue.extend({
  name: 'CommonInfiniteLoader',
  props: {
    infiniteLoaderCounter: Number,
    complete: Boolean,
    loadingBtnLoading: Boolean,
    listContainer: {
      type: Object as PropType<Element | null>,
      default: () => {return null}
    },
    parentIsLoading: Boolean,
  },
  data() {
    return {
      scrollValue: 0,
      toggle: true,
      maxAutoLoads: 5,
    }
  },
  methods: {
    getOneMorePage () {
      this.$emit('getOneMorePage')
    },
    isElementInViewport: function (el: Element) {
      var rect = el.getBoundingClientRect();
      return rect.bottom > 0 &&
          rect.right > 0 &&
          rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
          rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;

    },
    handleScroll () {
      this.scrollValue = window.scrollY
      const loadingContainer = document.getElementById('loading-container')
      if(loadingContainer && this.infiniteLoaderCounter < this.maxAutoLoads) {
        if(this.isElementInViewport(loadingContainer)) {
          if(this.toggle) {
            this.$emit("getOneMorePage");
            this.toggle = false
          }
        }
      }
    },
  },
  watch: {
    parentIsLoading: function (newVal: boolean) {
      if(!newVal) {
        this.toggle = true
      }
    }
  },
  mounted() {
    if (process.client) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed() {
    if(process.client) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
})
